export type PromocodeActivationStatsItem = {
  month: string;
  count: number;
};

export type PromocodeActivationStatsResponse = {
  data: PromocodeActivationStatsItem[];
  total: number;
};

type NivoLinePoint = {
  x: string;
  y: number;
};

type NivoLineSeries = {
  id: string;
  color: string;
  data: NivoLinePoint[];
};

const ACTIVATIONS_LINE_COLOR = 'rgb(133, 224, 171)';

export const hasPromocodeActivationData = (
  stats: PromocodeActivationStatsItem[],
) => stats.some((item) => item.count > 0);

export const preparePromocodeActivationsChartData = (
  stats: PromocodeActivationStatsItem[],
): NivoLineSeries[] => [
  {
    id: 'activations',
    color: ACTIVATIONS_LINE_COLOR,
    data: stats.map(({ month, count }) => ({
      x: `${month}-01`,
      y: count,
    })),
  },
];
